import { ActionType } from 'components/atoms/actions'
import { IActionRow } from 'interfaces'

export const ActionsEditDelete: Array<IActionRow> = [
  { actionType: ActionType.Edit, img: '/images/ic-edit.svg', disabled: false },
  {
    actionType: ActionType.Delete,
    img: '/images/ic-delete.svg',
    disabled: false
  }
]
export const ActionDisable: Array<IActionRow> = [
  { actionType: ActionType.Edit, img: '/images/ic-edit.svg', disabled: true },
  {
    actionType: ActionType.Delete,
    img: '/images/ic-delete.svg',
    disabled: true
  }
]

export const ActionsEdit: Array<IActionRow> = [
  { actionType: ActionType.Edit, img: '/images/ic-edit.svg', disabled: false }
]

export const ActionsDelete: Array<IActionRow> = [
  {
    actionType: ActionType.Delete,
    img: '/images/ic-delete.svg',
    disabled: false
  }
]

export const ActionsAccept: Array<IActionRow> = [
  {
    actionType: ActionType.Accept,
    img: '/images/ic-accept.svg',
    disabled: false
  }
]

export const ActionAcceptUpdateDelete: Array<IActionRow> = [
  {
    actionType: ActionType.Accept,
    img: '/images/ic-accept.svg',
    disabled: false
  },
  {
    actionType: ActionType.Reload,
    img: '/images/ic-reload.svg',
    disabled: false
  },
  {
    actionType: ActionType.Delete,
    img: '/images/ic-delete.svg',
    disabled: false
  }
]

export const ActionAcceptDelete: Array<IActionRow> = [
  {
    actionType: ActionType.Accept,
    img: '/images/ic-accept.svg',
    disabled: false
  },
  {
    actionType: ActionType.Delete,
    img: '/images/ic-delete.svg',
    disabled: false
  }
]

export const ActionPrintDeleteSend: Array<IActionRow> = [
  {
    actionType: ActionType.Print,
    img: '/images/ic-printer.svg',
    disabled: false
  },
  {
    actionType: ActionType.Delete,
    img: '/images/ic-delete.svg',
    disabled: false
  },
  {
    actionType: ActionType.Send,
    img: '/images/ic-send-action.svg',
    disabled: false
  }
]
